import React from 'react'
import FlexContainer from '@components/common/FlexContainer'
import Input from '@components/common/form/Input'
import Checkbox from '@components/common/form/Checkbox'
import YSpacing from '@components/common/YSpacing'
import LabelInfo from '@components/common/form/LabelInfo'
import { Schedule } from '../types'
import { formatCutoffTime, parseCutoffTimeInput } from '../utils'

interface Props {
  schedule: Schedule
  onUpdate: (partial: Partial<Schedule>) => void
}

const DefaultTimesForm: React.FC<Props> = ({ schedule, onUpdate }) => {
  const hasCutoffOverride =
    schedule.defaultCutoffDaysBefore != null &&
    schedule.defaultCutoffTime != null
  const hasDropoffOverride = schedule.defaultDropoffTime != null

  return (
    <div>
      <LabelInfo label="Unchecked fields inherit from global schedule settings." />
      <YSpacing height="6px" />

      {/* Cutoff override */}
      <Checkbox
        label="Override default cutoff time for this schedule"
        value="cutoff-override"
        checked={hasCutoffOverride}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          if (e.target.checked) {
            onUpdate({ defaultCutoffDaysBefore: 1, defaultCutoffTime: 1400 })
          } else {
            onUpdate({ defaultCutoffDaysBefore: null, defaultCutoffTime: null })
          }
        }}
      />

      {hasCutoffOverride && (
        <>
          <YSpacing height="4px" />
          <FlexContainer
            width="100%"
            justifyContent="space-between"
            alignItems="flex-end"
          >
            <Input
              label="Cutoff Days Before"
              width="48%"
              type="number"
              min="0"
              max="14"
              value={(schedule.defaultCutoffDaysBefore ?? 0).toString()}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                onUpdate({
                  defaultCutoffDaysBefore: e.target.valueAsNumber || 0,
                })
              }
            />
            <Input
              label="Cutoff Time"
              width="48%"
              type="time"
              value={formatCutoffTime(schedule.defaultCutoffTime ?? 0)}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                onUpdate({
                  defaultCutoffTime: parseCutoffTimeInput(e.target.value),
                })
              }
            />
          </FlexContainer>
        </>
      )}

      <YSpacing height="8px" />

      {/* Dropoff override */}
      <Checkbox
        label="Override default dropoff time for this schedule"
        value="dropoff-override"
        checked={hasDropoffOverride}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          if (e.target.checked) {
            onUpdate({ defaultDropoffTime: 1130 })
          } else {
            onUpdate({ defaultDropoffTime: null })
          }
        }}
      />

      {hasDropoffOverride && (
        <>
          <YSpacing height="4px" />
          <Input
            label="Dropoff Time"
            width="48%"
            type="time"
            value={formatCutoffTime(schedule.defaultDropoffTime ?? 0)}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              onUpdate({
                defaultDropoffTime: parseCutoffTimeInput(e.target.value),
              })
            }
          />
        </>
      )}
    </div>
  )
}

export default DefaultTimesForm
